import { urlOnlyQuery } from '/graphql/discovery/productResultPage.fragment'

import Retry from 'Clutch/Utilities/Retry'
import GraphQLRequest from 'Utilities/GraphQLClient/GraphQLClient'

const spaFetch = async (clickEvent, url, callback, skippedCriticalAttributes) => {
  try {
    if (clickEvent) {
      clickEvent.preventDefault()
    }

    let fitmentCookieJson

    try {
      const fitmentCookie = document.cookie.split(';').filter((cookie) => cookie.includes('FitmentCookie'))[0]

      if (fitmentCookie) {
        const trimmedFitmentCookie = fitmentCookie.trim()
        if (trimmedFitmentCookie.startsWith('FitmentCookie=') && trimmedFitmentCookie.includes('{')) {
          fitmentCookieJson = encodeURIComponent(trimmedFitmentCookie.substring(14))
        }
      }
    } catch (err) {
      console.error('There was an error getting the fitment cookie', err)
    }

    const variables = {
      url,
      skippedCriticalAttributes,
      lazyLoadFacets: false, // eagerly load the facets when you're navigating with facets
    }

    if (fitmentCookieJson) {
      variables.fitmentCookieJson = fitmentCookieJson
    }

    const response = await Retry(() => GraphQLRequest('/graphql/discovery', urlOnlyQuery, variables))

    if (response.productResultPageFromUrlOnly.redirectUrl) {
      console.error(`spa rerender redirect from ${url} to ${response.productResultPageFromUrlOnly.redirectUrl}`)
      window.location.href = response.productResultPageFromUrlOnly.redirectUrl
      return
    }

    if (response.productResultPageFromUrlOnly.should404) {
      const err = new Error(`spa rerender got a 404! ${url}`)
      err.statusCode = 404
      throw err
    }

    window.history.pushState(
      response.productResultPageFromUrlOnly,
      response.productResultPageFromUrlOnly.pageTitle,
      window.location.origin + url,
    )
    callback()
    return response.productResultPageFromUrlOnly
  } catch (err) {
    console.error('spa rerender error', err)
    window.location.href = url
  }
}

export default spaFetch
